import React, { FC } from 'react'
import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'
import { colors } from '../styles/colors'
import { Typography } from './Typography'

export const ModerationBadge: FC<{
  className?: string
}> = ({ className }) => {
  return (
    <TextContainer
      className={className}
      fontSize={10}
      fontWeight={400}
      color={colors.white}
      font="roboto"
    >
      <Dot />
      <FormattedMessage id="moderation.badge" defaultMessage="На модерации" />
    </TextContainer>
  )
}

const TextContainer = styled(Typography)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${colors.warning};
  flex-shrink: 0;
`
